import "./App.css";
import Navbar from "./components/Navbar.jsx";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Profile from "./pages/Profile";
import Dashboard from "./pages/Dashboard";
import Payments from "./pages/Payments";
import Resumes from "./pages/Resumes";
import ResumeEditor from "./pages/ResumeEditor";
import PaymentSuccess from "./pages/PaymentSuccess";
import { useState, useEffect, useContext } from "react";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { AuthContext } from "./AuthContext.js";

function App() {
  const { session, updateSession, supabase } = useContext(AuthContext);
  const location = window.location.pathname;

  const monthlyAccess = {
    name: "Monthly Resume Generation",
    description: "Unlimited AI-powered resume generation for 30 days",
    amount: 1500,
  };

  const lifetimeAccess = {
    name: "Lifetime Resume Generation",
    description: "Unlimited AI-powered resume generation forever!",
    amount: 15000,
  };

  if (!session) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="bg-white p-8 rounded-lg shadow-md w-96">
          <h2 className="text-2xl font-bold text-center mb-6">
            Welcome to Hired AI
          </h2>
          <Auth
            supabaseClient={supabase}
            appearance={{ theme: ThemeSupa }}
            providers={["google"]}
            redirectTo={`${window.location.origin}${location}`}
          />
        </div>
      </div>
    );
  } else {
    return (
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Navigate to="/profile" />} />
          <Route
            path="/payments/15"
            element={<Payments purchaseDetails={monthlyAccess} />}
          />
          <Route
            path="/payments/150"
            element={<Payments purchaseDetails={lifetimeAccess} />}
          />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/home" element={<Dashboard />} />
          <Route path="/resumes" element={<Resumes />} />
          <Route path="/resume-editor" element={<ResumeEditor />} />
        </Routes>
      </div>
    );
  }
}

export default App;
